import React, { useState, useEffect, } from 'react';
import orderServiceInstance from '../../../APIs/order';
import { useAuth } from '../../AuthContext/AuthContext';

import OrderTable from '../OrderTable/OrderTable';



export interface Product {
  name: string;
  price: number;
  quantity: number;
  product_id: number;
  order_type: string;
}

export interface Order {
  id: number;
  status: string;
  address_id: string;
  vat: number;
  grand_total: number;
  total_price: number;
  date_ordered: string | null;
  requested_ship_date: string;
  reference_number: string;
  user_id: number;
  products: Product[];
  receipt_url: string | null;
  quote_status:string;
  quote_id:string;
  latest_status:string

}

const MyOrders: React.FC = () => {
  const [orders, setOrders] = useState<Order[]>([]);

  const [error, setError] = useState<string | null>(null);
  const { user,  } = useAuth();


  useEffect(() => {
    const fetchOrders = async () => {
      if (!user?.id) {
        console.warn('User ID is not defined.');
        return;
      }
  
      try {
      
        const result = await orderServiceInstance.getOrderByUserId(user.id);
        if (result.data) {
          setOrders(result.data || []);
         
        } else {
    
        }
      } catch (err) {
        setError(JSON.stringify(err));
      }
     
    };
  
    fetchOrders();
  }, [user?.id]);
  
  
 
  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div>
   
    <div className="hidden sm:block mt-[-40px]">
    <div className="text-center py-2 mb-3 mt-[-40px]">
      <p className=" box-border font-semibold text-[rgb(0,34,56)] block  text-[35px]  text-left h-[38px]
       leading-[38.4px] mb-1">
      My Orders
      </p>
    </div>
    {  <OrderTable orders={orders} />}
    </div>

   
   
  </div>
  );
};

export default MyOrders;